import Loadable from 'components/Loadable';
import { ROLES } from 'models/Roles';
import { IRoute } from 'models/route';
import { lazy } from 'react';
import { LessonType } from '../constants/enums';

const ListOfRegions = Loadable(
	lazy(() => import('modules/RegionsConfiguration/pages/ListOfRegions')),
);
const ListLessonsByRegion = Loadable(
	lazy(() => import('modules/RegionsConfiguration/pages/ListLessonsByRegion')),
);

const AddVocabLesson = Loadable(
	lazy(() => import('modules/RegionsConfiguration/pages/AddVocabLesson')),
);

const UpdateVocabLesson = Loadable(
	lazy(() => import('modules/RegionsConfiguration/pages/UpdateVocabLesson')),
);

const AddVerbLesson = Loadable(
	lazy(() => import('modules/RegionsConfiguration/pages/AddVerbLesson')),
);

const UpdateVerbLesson = Loadable(
	lazy(() => import('modules/RegionsConfiguration/pages/UpdateVerbLesson')),
);

const AddSentenceLesson = Loadable(
	lazy(() => import('modules/RegionsConfiguration/pages/AddSentenceLesson')),
);

const UpdateSentenceLesson = Loadable(
	lazy(() => import('modules/RegionsConfiguration/pages/UpdateSentenceLesson')),
);

const AddLexicaryLesson = Loadable(
	lazy(() => import('modules/RegionsConfiguration/pages/AddLexicaryLesson')),
);

const UpdateLexicaryLesson = Loadable(
	lazy(() => import('modules/RegionsConfiguration/pages/UpdateLexicaryLesson')),
);

const AddGrammarLesson = Loadable(
	lazy(() => import('modules/RegionsConfiguration/pages/AddGrammarLesson')),
);

const UpdateGrammarLesson = Loadable(
	lazy(() => import('modules/RegionsConfiguration/pages/UpdateGrammarLesson')),
);

const AddSortingLesson = Loadable(
	lazy(() => import('modules/RegionsConfiguration/pages/AddSortingLesson')),
);

const UpdateSortingLesson = Loadable(
	lazy(() => import('modules/RegionsConfiguration/pages/UpdateSortingLesson')),
);

const ListLessonCategories = Loadable(
	lazy(() => import('modules/RegionsConfiguration/pages/ListLessonCategories')),
);

const AddBusyPictureLesson = Loadable(
	lazy(() => import('modules/RegionsConfiguration/pages/AddBusyPictureLesson')),
);

const UpdateBusyPictureLesson = Loadable(
	lazy(
		() => import('modules/RegionsConfiguration/pages/UpdateBusyPictureLesson'),
	),
);

const AddNumberCombinationLesson = Loadable(
	lazy(
		() =>
			import('modules/RegionsConfiguration/pages/AddNumberCombinationLesson'),
	),
);

const UpdateNumberCombinationLesson = Loadable(
	lazy(
		() =>
			import(
				'modules/RegionsConfiguration/pages/UpdateNumberCombinationLesson'
			),
	),
);

const AddSightWordsLesson = Loadable(
	lazy(() => import('modules/RegionsConfiguration/pages/AddSightWordsLesson')),
);

const UpdateSightWordsLesson = Loadable(
	lazy(
		() => import('modules/RegionsConfiguration/pages/UpdateSightWordsLesson'),
	),
);

const AddTimeLesson = Loadable(
	lazy(() => import('modules/RegionsConfiguration/pages/AddTimeLesson')),
);

const UpdateTimeLesson = Loadable(
	lazy(() => import('modules/RegionsConfiguration/pages/UpdateTimeLesson')),
);

const AddSceneMatchingLesson = Loadable(
	lazy(
		() => import('modules/RegionsConfiguration/pages/AddSceneMatchingLesson'),
	),
);

const UpdateSceneMatchingLesson = Loadable(
	lazy(
		() =>
			import('modules/RegionsConfiguration/pages/UpdateSceneMatchingLesson'),
	),
);

const REGIONS_CONFIGURATION_ROUTES: IRoute[] = [
	{
		path: 'list-of-regions',
		element: ListOfRegions,
		name: 'ListOfRegions',
		roles: [ROLES.ADMIN],
		private: true,
	},
	{
		path: 'list-of-regions/:regionId',
		element: ListLessonsByRegion,
		name: 'ListLessonsByRegion',
		roles: [ROLES.ADMIN],
		private: true,
	},
	{
		path: `list-of-regions/:regionId/${LessonType.VOCAB}/add`,
		element: AddVocabLesson,
		name: 'AddVocabLesson',
		roles: [ROLES.ADMIN],
		private: true,
	},
	{
		path: `list-of-regions/:regionId/${LessonType.VOCAB}/update/:lessonId`,
		element: UpdateVocabLesson,
		name: 'UpdateVocabLesson',
		roles: [ROLES.ADMIN],
		private: true,
	},
	{
		path: `list-of-regions/:regionId/${LessonType.VERB}/add`,
		element: AddVerbLesson,
		name: 'AddVerbLesson',
		roles: [ROLES.ADMIN],
		private: true,
	},
	{
		path: `list-of-regions/:regionId/${LessonType.VERB}/update/:lessonId`,
		element: UpdateVerbLesson,
		name: 'UpdateVerbLesson',
		roles: [ROLES.ADMIN],
		private: true,
	},
	{
		path: `list-of-regions/:regionId/${LessonType.SENTENCE}/add`,
		element: AddSentenceLesson,
		name: 'AddSentenceLesson',
		roles: [ROLES.ADMIN],
		private: true,
	},

	{
		path: `list-of-regions/:regionId/${LessonType.SENTENCE}/update/:lessonId`,
		element: UpdateSentenceLesson,
		name: 'UpdateSentenceLesson',
		roles: [ROLES.ADMIN],
		private: true,
	},

	{
		path: `list-of-regions/:regionId/${LessonType.LEXICAL}/add`,
		element: AddLexicaryLesson,
		name: 'AddLexicaryLesson',
		roles: [ROLES.ADMIN],
		private: true,
	},

	{
		path: `list-of-regions/:regionId/${LessonType.LEXICAL}/update/:lessonId`,
		element: UpdateLexicaryLesson,
		name: 'UpdateLexicaryLesson',
		roles: [ROLES.ADMIN],
		private: true,
	},

	{
		path: `list-of-regions/:regionId/${LessonType.GRAMMAR}/add`,
		element: AddGrammarLesson,
		name: 'AddGrammarLesson',
		roles: [ROLES.ADMIN],
		private: true,
	},

	{
		path: `list-of-regions/:regionId/${LessonType.GRAMMAR}/update/:lessonId`,
		element: UpdateGrammarLesson,
		name: 'AddGrammarLesson',
		roles: [ROLES.ADMIN],
		private: true,
	},

	{
		path: `list-of-regions/:regionId/${LessonType.SORTING}/add`,
		element: AddSortingLesson,
		name: 'AddSortingLesson',
		roles: [ROLES.ADMIN],
		private: true,
	},
	{
		path: `list-of-regions/:regionId/${LessonType.SORTING}/update/:lessonId`,
		element: UpdateSortingLesson,
		name: 'AddSortingLesson',
		roles: [ROLES.ADMIN],
		private: true,
	},
	{
		path: 'lesson-categories',
		element: ListLessonCategories,
		name: 'ListLessonCategories',
		roles: [ROLES.ADMIN],
		private: true,
	},
	{
		path: `list-of-regions/:regionId/${LessonType.BUSY_PICTURE}/add`,
		element: AddBusyPictureLesson,
		name: 'AddBusyPictureLesson',
		roles: [ROLES.ADMIN],
		private: true,
	},
	{
		path: `list-of-regions/:regionId/${LessonType.BUSY_PICTURE}/update/:lessonId`,
		element: UpdateBusyPictureLesson,
		name: 'UpdateBusyPictureLesson',
		roles: [ROLES.ADMIN],
		private: true,
	},

	{
		path: `list-of-regions/:regionId/${LessonType.NUMBER_COMBINATION}/add`,
		element: AddNumberCombinationLesson,
		name: 'AddNumberCombinationLesson',
		roles: [ROLES.ADMIN],
		private: true,
	},
	{
		path: `list-of-regions/:regionId/${LessonType.NUMBER_COMBINATION}/update/:lessonId`,
		element: UpdateNumberCombinationLesson,
		name: 'UpdateNumberCombinationLesson',
		roles: [ROLES.ADMIN],
		private: true,
	},
	{
		path: `list-of-regions/:regionId/${LessonType.SIGHT_WORDS}/add`,
		element: AddSightWordsLesson,
		name: 'AddSightWordsLesson',
		roles: [ROLES.ADMIN],
		private: true,
	},
	{
		path: `list-of-regions/:regionId/${LessonType.SIGHT_WORDS}/update/:lessonId`,
		element: UpdateSightWordsLesson,
		name: 'UpdateSightWordsLesson',
		roles: [ROLES.ADMIN],
		private: true,
	},

	{
		path: `list-of-regions/:regionId/${LessonType.TIME}/add`,
		element: AddTimeLesson,
		name: 'AddTimeLesson',
		roles: [ROLES.ADMIN],
		private: true,
	},
	{
		path: `list-of-regions/:regionId/${LessonType.TIME}/update/:lessonId`,
		element: UpdateTimeLesson,
		name: 'UpdateTimeLesson',
		roles: [ROLES.ADMIN],
		private: true,
	},

	{
		path: `list-of-regions/:regionId/${LessonType.SCENE_MATCHING}/add`,
		element: AddSceneMatchingLesson,
		name: 'AddSceneMatchingLesson',
		roles: [ROLES.ADMIN],
		private: true,
	},
	{
		path: `list-of-regions/:regionId/${LessonType.SCENE_MATCHING}/update/:lessonId`,
		element: UpdateSceneMatchingLesson,
		name: 'UpdateSceneMatchingLesson',
		roles: [ROLES.ADMIN],
		private: true,
	},
];

export default REGIONS_CONFIGURATION_ROUTES;
